var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"keyTime",staticClass:"mx-4",attrs:{"label":_vm.label,"outlined":"","dense":"","hint":_vm.$t('common.format-time'),"persistent-hint":"","rules":_vm.rulesTime},on:{"keypress":_vm.restrictFormat,"input":_vm.saveTime},model:{value:(_vm.keyTime),callback:function ($$v) {_vm.keyTime=$$v},expression:"keyTime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }